import { Controller } from "@hotwired/stimulus";

// Back-to-top button. The threshold is read once on connect, load and width
// change, never per scroll event: reading offsetHeight on every scroll forces
// a reflow and makes the page stutter on mobile.
//
// Upstream computes this hero-based threshold for the shop header's sticky
// class and gates the button itself on a flat y > 500. We have no shop header,
// so the threshold drives the button: it appears once the hero has scrolled
// past, which is what the flat 500 approximates on the source layout.

export default class extends Controller {
  connect() {
    this.onScroll = () => this.update();
    this.onResize = () => {
      // On mobile the address bar sliding away fires resize mid-scroll with the
      // same width, so only a real width change recomputes the threshold.
      if (window.innerWidth === this.lastWidth) return;
      this.lastWidth = window.innerWidth;
      this.measure();
      this.update();
    };
    this.onLoad = () => this.measure();

    this.lastWidth = window.innerWidth;
    this.measure();
    this.update();
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onResize, { passive: true });
    window.addEventListener("load", this.onLoad);
    this.timer = setTimeout(this.onLoad, 400);
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("load", this.onLoad);
    clearTimeout(this.timer);
  }

  scrollTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  // ---- internals ----

  // Pages without a hero (the secondary pages) fall back to most of a screen.
  measure() {
    const hero = document.querySelector(".med-hero");
    this.threshold = hero ? hero.offsetHeight - 70 : window.innerHeight * 0.8;
  }

  update() {
    const y = window.pageYOffset || document.documentElement.scrollTop;
    this.element.classList.toggle("is-visible", y > this.threshold);
  }
}
